/* ============================================================
   GEBERT & WESCHKA — Sofortangebot (nativ im Theme)
   Formular → AXIS-Preis-Engine (quote.gebertweschka.de, CORS).
   STEP/STL-Upload → Maße/Volumen → Sofortpreis → Shopify-Checkout.
   Kein iframe, keine Preis-Engine im Client (Preis kommt vom Server).
   ============================================================ */
(function () {
  'use strict';

  // Sortiment = real verfügbar (gemessen 19.07.2026):
  // TPU nur FDM, PA11 nur MJF — deshalb dort einsortiert.
  var PRINT_MATS = {
    FDM: [['pla', 'PLA'], ['tpu', 'TPU (flexibel)'], ['abs', 'ABS'], ['asa', 'ASA'], ['pa', 'PA12-CF (Nylon)']],
    SLA: [['standard', 'Standard-Resin'], ['tough', 'Tough-Resin'], ['clear', 'Clear-Resin (transparent)'], ['black', 'Black-Resin']],
    SLS: [['pa12', 'PA12']],
    MJF: [['pa12hp', 'PA12-HP'], ['pa11hp', 'PA11-HP']]
  };

  function eur(n) {
    try { return Number(n).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return (Math.round(Number(n) * 100) / 100) + ' €'; }
  }
  // Versand kommt brutto aus der Engine (so geht er in die Kasse); angezeigt wird er netto wie in Angebotsmail und Konto.
  function versandNetto(n) { return Math.round(Number(n) / 1.19 * 100) / 100; }
  function num2(n) {   // 12,34 — ohne Währungszeichen (Staffelkacheln; „€" steht in der Überschrift)
    try { return Number(n).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return String(Math.round(Number(n) * 100) / 100); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Übergabe an den großen STEP-Viewer in einem neuen Tab: Der neue Tab liest die Datei direkt aus
  // diesem Fenster (window.opener.__gwHandoff, gleiche Herkunft). Kein Speichern im Browser, kein Upload.
  function offerHandoff(file) { window.__gwHandoff = { file: file, ts: Date.now() }; }
  function portalClear() {   // Viewer (auch im anderen Tab): Datei ist nicht mehr im Formular
    window.__gwHandoff = null;
    document.dispatchEvent(new CustomEvent('gw:portal-clear'));
  }

  function initPortal(root) {
    if (root.__gwqp) return; root.__gwqp = true;
    var api = (root.getAttribute('data-api') || 'https://quote.gebertweschka.de').replace(/\/+$/, '');
    var form = root.querySelector('.gw-qp-form');
    var resultEl = root.querySelector('.gw-qp-result');
    var errEl = root.querySelector('.gw-qp-error:not([data-ort])');
    var upErr = root.querySelector('.gw-qp-error[data-ort="upload"]');   // nur „einfach“: Upload-Meldungen oben
    var labelEl = root.querySelector('.gw-qp-label');
    var cncGroup = root.querySelector('.gw-qp-cnc');
    var printGroup = root.querySelector('.gw-qp-print');
    var submitBtn = root.querySelector('.gw-qp-submit');
    var submitTxt = root.querySelector('.gw-qp-submit-txt');
    var no3d = root.getAttribute('data-no3d') === '1';
    var einfach = root.getAttribute('data-ux') === 'einfach';   // Variante: erst die Datei, dann die Fragen
    // Anonyme Tageszähler (02.11.2026): nur Seite, Variante, erste Vorschau, Beispielteil — keine Kennung, kein Cookie
    var kzErst = true;
    function kz(erst) {
      return '?s=' + encodeURIComponent(location.pathname) + '&ux=' + (einfach ? 'einfach' : 'klassisch') +
        (erst ? '&erst=1' : '') + (state && state.beispiel ? '&bsp=1' : '');
    }
    var srEl = root.querySelector('.gw-qp-sr'), letzteAnsage = '', letzterPreis = '', pvLaeuft = false;
    var previewWrap = root.querySelector('.gw-qp-preview');
    var pvEl = root.querySelector('.gw-qp-pv');
    var pvClose = root.querySelector('.gw-qp-pv-x');

    var state = { mode: 'cnc', stepFile: null, drawingFile: null, stepName: null, drawingName: null, volumeCm3: null, removalPct: null, holes: null, parts: [], lastLive: null };
    var partsWrap = root.querySelector('.gw-qp-parts');
    var partsList = root.querySelector('.gw-qp-parts-list');
    var partsSum = root.querySelector('.gw-qp-parts-sum');
    var addBtn = root.querySelector('.gw-qp-add');

    // ---- Kundenkonto (26.09.2026): angemeldet → Ticket holen (Bindung ans Konto, Willkommensvorteil) ----
    // Ohne eingerichteten App-Proxy schlägt das still fehl — das Werkzeug arbeitet dann wie für Gäste.
    var konto = root.getAttribute('data-konto') === '1';
    var kontoSeite = root.getAttribute('data-konto-seite') || '';
    // Gast bei eingeschaltetem Konto (18.10.2026): Hinweis auf den Willkommensvorteil am Sofortpreis. Wer sich in einem
    // zweiten Tab anmeldet, bleibt hier im Formular; beim Absenden wird das Ticket trotzdem geholt.
    var kontoMoeglich = root.getAttribute('data-konto-moeglich') === '1';
    var werbenPct = parseInt(root.getAttribute('data-werben') || '0', 10) || 0;
    var loginUrl = root.getAttribute('data-login') || '/customer_authentication/login';
    function kontoTicket(frisch) {
      if ((!konto && !kontoMoeglich) || !window.GWKonto) return Promise.resolve(null);
      return window.GWKonto.ticket(frisch).catch(function () { return null; });
    }
    if (konto) kontoTicket().then(function (t) {
      if (!t || !t.willkommen || !t.willkommen.prozent) return;
      root.querySelectorAll('[data-konto-vorteil]').forEach(function (el) {
        el.hidden = false;
        el.textContent = t.willkommen.prozent + ' % Willkommensvorteil auf Ihre erste Bestellung – beim Sofortpreis und in unseren Angeboten abgezogen (ohne Versand).';
      });
    });

    var werbenEl = null, kontoPruefZeit = 0;
    /** Anmeldung (z. B. im zweiten Tab) erkannt: Konto-Zeile, Vorbelegung und Hinweis umstellen. */
    function kontoErkannt(t) {
      if (!t || !t.ticket || konto) return;
      konto = true;
      var mail = t.email ? String(t.email) : '';
      root.querySelectorAll('.gw-konto-zeile').forEach(function (el) {
        el.innerHTML = 'Angemeldet als <strong></strong> – das Angebot erscheint in Ihrem Konto.';
        el.querySelector('strong').textContent = mail;
      });
      var setz = function (n, w) { root.querySelectorAll('[name="' + n + '"]').forEach(function (f) { if (w && !f.value) f.value = w; }); };
      setz('email', mail); setz('customerName', [t.vorname, t.nachname].filter(Boolean).join(' ')); setz('company', t.firma || '');
      if (werbenEl && !werbenEl.hidden) {
        werbenEl.innerHTML = '<p class="gw-qp-werben-ok">' + (t.willkommen && t.willkommen.prozent
          ? 'Angemeldet – Ihr Willkommensvorteil von ' + t.willkommen.prozent + ' % wird beim Angebot abgezogen.'
          : 'Angemeldet – das Angebot erscheint in Ihrem Konto.') + '</p>';
      }
      werbenPct = 0;
    }
    function kontoNachpruefen() {
      if (konto || !kontoMoeglich || Date.now() - kontoPruefZeit < 3000) return;
      kontoPruefZeit = Date.now();
      kontoTicket(true).then(kontoErkannt);
    }
    if (kontoMoeglich) {
      window.addEventListener('focus', kontoNachpruefen);
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') kontoNachpruefen(); });
    }
    /** Gäste: Ersparnis mit Konto unter dem Sofortpreis (Vorschau; der echte Abzug kommt vom Server). */
    function werben(d) {
      if (!liveEl) return;
      if (!werbenPct || konto || !d || !d.ok) { if (werbenEl) werbenEl.hidden = true; return; }
      if (!werbenEl) { werbenEl = document.createElement('div'); werbenEl.className = 'gw-qp-werben'; liveEl.insertAdjacentElement('afterend', werbenEl); }
      var bed = '* Erste Bestellung mit Kundenkonto, einmal je Firma, nicht für Aluprofile, Versand ausgenommen.';
      var los = '<a class="gw-qp-werben-btn" href="' + loginUrl + '" target="_blank" rel="noopener nofollow">Konto anlegen und sparen</a>';
      var tab = 'Die Anmeldung öffnet sich in einem neuen Tab – Ihre Eingaben hier bleiben erhalten. Bestellen geht auch ohne Konto.';
      if (d.autoQuote && d.vkOrderNet > 0) {
        var mit = Math.round(d.vkOrderNet * (100 - werbenPct)) / 100;
        var spar = Math.round((d.vkOrderNet - mit) * 100) / 100;
        werbenEl.innerHTML = '<div class="gw-qp-werben-zeile"><div><strong>Mit Kundenkonto ' + eur(mit) + ' netto</strong>' +
          '<span>Sie sparen ' + eur(spar) + ' bei Ihrer ersten Bestellung*</span></div>' + los + '</div><small>' + tab + ' ' + bed + '</small>';
      } else {
        werbenEl.innerHTML = '<div class="gw-qp-werben-zeile"><div><strong>Mit Kundenkonto ' + werbenPct + ' % auf Ihr Angebot</strong>' +
          '<span>Bei Ihrer ersten Bestellung*</span></div>' + los + '</div><small>' + tab + ' ' + bed + '</small>';
      }
      werbenEl.hidden = false;
    }

    function showPreview(source) {
      if (!previewWrap || !pvEl || !window.GWPartViewer) return;
      previewWrap.hidden = false;
      window.GWPartViewer.render(pvEl, source).catch(function () { previewWrap.hidden = true; });
    }
    function hidePreview() {
      if (!previewWrap) return;
      previewWrap.hidden = true;
      if (window.GWPartViewer) window.GWPartViewer.clear(pvEl);
    }
    if (pvClose) pvClose.addEventListener('click', function () { hidePreview(); if (einfach) fokus(root.querySelector('.gw-qp-teil-h')); });

    // ---- Weg in den großen STEP-Viewer (messen, schneiden, Bohrungen) ----
    // Gleiche Seite: Ereignis „gw:open-viewer" → der Viewer öffnet sich im Vollbild.
    // Andere Seite: Viewer-Seite im neuen Tab; der neue Tab holt die Datei direkt aus diesem Fenster.
    // Das ausgefüllte Formular bleibt in diesem Tab stehen.
    var pvOpen = root.querySelector('.gw-qp-pv-open');
    var pvLink = root.querySelector('.gw-qp-pv-link');
    var viewerUrl = root.getAttribute('data-viewer') || '/pages/sofortangebot-cnc#step-viewer';
    var viewerTabUrl = (function () { var p = viewerUrl.split('#'); return p[0] + (p[0].indexOf('?') >= 0 ? '&' : '?') + 'gwsv=1' + (p[1] ? '#' + p[1] : ''); })();
    if (pvLink) pvLink.setAttribute('href', viewerTabUrl);
    function updateOpenBtn() { if (pvOpen) pvOpen.hidden = !state.stepLocal; if (pvLink && !state.stepLocal) pvLink.hidden = true; }
    var openLock = 0;
    if (pvOpen) pvOpen.addEventListener('click', function () {
      var f = state.stepLocal; if (!f) return;
      if (Date.now() - openLock < 1500) return;   // Doppelklick öffnet nicht zwei Tabs
      openLock = Date.now();
      var ev = new CustomEvent('gw:open-viewer', { detail: { file: f }, cancelable: true });
      document.dispatchEvent(ev);
      if (ev.defaultPrevented) return;   // großer Viewer auf dieser Seite hat übernommen
      offerHandoff(f);
      var w = null; try { w = window.open(viewerTabUrl, '_blank'); } catch (e) {}   // synchron im Klick, sonst greift der Popup-Blocker
      if (!w && pvLink) {   // Popup blockiert: Link direkt in der Vorschau anbieten — das Formular bleibt erhalten
        pvLink.textContent = 'Neuer Tab wurde blockiert – hier öffnen ↗';
        pvLink.hidden = false;
      }
    });
    if (pvLink) pvLink.addEventListener('click', function () { if (state.stepLocal) offerHandoff(state.stepLocal); pvLink.hidden = true; });

    // ---- Live-Preisvorschau (serverseitig, entzerrt) ----
    var liveEl = root.querySelector('.gw-qp-live');
    var pvTimer = null, pvSeq = 0;

    function techBody() {
      var qtyEl = (state.mode === 'print' ? printGroup : cncGroup).querySelector('[name="quantity"]');
      var b = {
        lengthMm: root.querySelector('[name="lengthMm"]').value,
        widthMm: root.querySelector('[name="widthMm"]').value,
        heightMm: root.querySelector('[name="heightMm"]').value,
        quantity: Number(qtyEl && qtyEl.value) || 1,
        express: !!root.querySelector('[name="express"]').checked
      };
      if (state.mode === 'print') {
        b.kind = 'print';
        b.process = printGroup.querySelector('[name="process"]').value;
        b.material = printGroup.querySelector('[name="printMaterial"]').value;
        b.volumeCm3 = state.volumeCm3;
      } else {
        b.material = cncGroup.querySelector('[name="material"]').value;
        b.surface = cncGroup.querySelector('[name="surface"]').value;
        b.tolerance = cncGroup.querySelector('[name="tolerance"]').value;
        b.removalPct = state.removalPct;
        b.holes = state.holes;
        b.stepFile = state.stepFile || null;
        b.drawingFile = state.drawingFile || null;
      }
      return b;
    }

    // Welcher Weg beim Absenden? Gesammelte Teile + aktuelles Formular (sofern ausgefüllt).
    // Der Server legt einen gemischten Stapel komplett in die Prüfung; eine angehängte Zeichnung
    // liest er beim Absenden mit und kann Toleranz/Preis anheben oder auf Prüfung stellen.
    function submitWeg() {
      var st = state.parts.map(function (p) { return p._auto === true ? 'auto' : p._auto === false ? 'manual' : 'unknown'; });
      var mitZeichnung = state.parts.some(function (p) { return !!p.drawingFile; });
      if (!(state.parts.length && techEmpty())) {
        var L = state.lastLive;
        st.push(L ? (L.autoQuote ? 'auto' : 'manual') : 'unknown');
        if (state.drawingFile) mitZeichnung = true;
      }
      if (st.indexOf('manual') >= 0) return { key: 'manual', label: 'Anfrage zur Prüfung senden', busy: 'Wird gesendet …' };
      if (st.length && st.indexOf('unknown') < 0) return mitZeichnung
        ? { key: 'drawing', label: 'Angebot erstellen', busy: 'Wird erstellt …' }
        : { key: 'auto', label: 'Angebot mit Bestell-Link erstellen', busy: 'Wird erstellt …' };
      return { key: 'open', label: 'Anfrage senden', busy: 'Wird gesendet …' };
    }
    function updateSubmitLabel() {
      if (!submitTxt || submitBtn.disabled) return;
      submitTxt.textContent = submitWeg().label;
    }
    // Staffel: Stückpreis bei 1/5/10/20 (3D-Druck bis 50) — Klick setzt die Menge
    var tiersEl = root.querySelector('.gw-qp-tiers'), hintEl = root.querySelector('.gw-qp-pricehint');
    function renderTiers(d) {
      if (!tiersEl) return;
      var t = d && d.ok && Array.isArray(d.tiers) ? d.tiers : [];
      var priced = t.filter(function (x) { return x.auto !== false && x.unitNet != null; });
      if (priced.length < 2) { tiersEl.hidden = true; tiersEl.innerHTML = ''; return; }
      var qtyEl = (state.mode === 'print' ? printGroup : cncGroup).querySelector('[name="quantity"]');
      var cur = Number(qtyEl && qtyEl.value) || 1, base = priced[0].qty === 1 ? priced[0].unitNet : null;
      // Tastatur: Enter auf einer Stufe löst eine neue Vorschau aus, die die Knöpfe neu aufbaut — Fokus mitnehmen
      var fokus = document.activeElement && tiersEl.contains(document.activeElement) ? document.activeElement.getAttribute('data-qty') : null;
      tiersEl.innerHTML = '<p class="gw-qp-tiers-h">Stückpreis in € netto nach Menge — Klick übernimmt die Menge</p>' + t.map(function (x) {
        // Stufe ohne Sofortpreis: wählbar wie die anderen – die Menge geht dann als Anfrage in die Prüfung (30.10.2026)
        if (x.auto === false || x.unitNet == null) return '<button type="button" class="gw-qp-tier' + (x.qty === cur ? ' is-on' : '') + '" data-qty="' + x.qty + '" aria-pressed="' + (x.qty === cur) + '" aria-label="' + x.qty + ' Stück: individuelle Prüfung">' +
          '<b>' + x.qty + ' Stk.</b><span>Prüfung</span></button>';
        var save = base && x.qty > 1 ? Math.round((1 - x.unitNet / base) * 100) : 0;
        return '<button type="button" class="gw-qp-tier' + (x.qty === cur ? ' is-on' : '') + '" data-qty="' + x.qty + '" aria-pressed="' + (x.qty === cur) + '" aria-label="' + x.qty + ' Stück: ' + esc(eur(x.unitNet)) + ' pro Stück">' +
          '<b>' + x.qty + ' Stk.</b><span>' + num2(x.unitNet) + '</span>' + (save > 0 ? '<em>−' + save + ' %</em>' : '') + '</button>';
      }).join('');
      tiersEl.style.gridTemplateColumns = 'repeat(' + t.length + ', minmax(0, 1fr))';   // Stufen füllen die Zeile
      tiersEl.setAttribute('data-n', String(t.length));
      tiersEl.hidden = false;
      if (fokus) { var nb = tiersEl.querySelector('[data-qty="' + fokus + '"]'); if (nb) nb.focus(); }
    }
    if (tiersEl) tiersEl.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.gw-qp-tier[data-qty]') : null; if (!b) return;
      var qtyEl = (state.mode === 'print' ? printGroup : cncGroup).querySelector('[name="quantity"]');
      if (!qtyEl) return;
      qtyEl.value = b.getAttribute('data-qty');
      qtyEl.dispatchEvent(new Event('input', { bubbles: true }));   // löst die Preisvorschau aus
    });

    function renderLive(d) {
      state.lastLive = d && d.ok ? d : null;   // fürs „Teil hinzufügen" (Preis-Snapshot)
      renderTiers(d); updateSubmitLabel();
      if (hintEl) hintEl.hidden = !!(d && d.ok);
      if (!liveEl) { nachLive(d); return; }
      if (!d || !d.ok) { liveEl.hidden = true; liveEl.innerHTML = ''; liveEl.className = 'gw-qp-live'; werben(null); nachLive(d); return; }
      if (d.autoQuote) {
        liveEl.className = 'gw-qp-live gw-qp-live-ok';
        liveEl.innerHTML = '<div><span class="gw-qp-live-lbl">Sofortpreis (Vorschau)</span>' +
          '<strong>' + eur(d.vkOrderNet) + ' <em>netto</em></strong>' +
          '<span class="gw-qp-live-sub">' + eur(d.vkUnitNet) + '/St' + (d.shippingEur != null ? ' · Versand ca. ' + eur(versandNetto(d.shippingEur)) + ' netto' : '') + ' · Lieferung ca. ' + d.leadTimeDays + ' Werktage</span>' +
          (state.drawingFile ? '<span class="gw-qp-live-note">Ihre Zeichnung lesen wir beim Absenden mit – Passungen oder Sonderanforderungen können den Preis noch ändern.</span>' : '') + '</div>' +
          '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 16V8l-9-5-9 5v8l9 5 9-5z"/><path d="M3.3 7L12 12l8.7-5M12 22V12"/></svg>';
      } else {
        liveEl.className = 'gw-qp-live gw-qp-live-wait';
        liveEl.innerHTML = '<div><span class="gw-qp-live-lbl">Individuelle Prüfung</span>' +
          '<span class="gw-qp-live-sub">Dieses Teil kalkulieren wir von Hand — Ihr Angebot kommt binnen 24 Stunden.</span></div>' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
      }
      liveEl.hidden = false;
      werben(d);
      nachLive(d);
    }

    function runPreview() {
      var L = root.querySelector('[name="lengthMm"]').value, W = root.querySelector('[name="widthMm"]').value, H = root.querySelector('[name="heightMm"]').value;
      if (!L || !W || !H) { pvSeq++; pvLaeuft = false; state.pvFehler = false; state.masseUngueltig = false; renderLive(null); return; }
      var zahlen = [L, W, H].map(Number);
      if (zahlen.some(function (x) { return !(x > 0) || x > 3000; })) {   // Grenzen wie /api/quote (route.ts)
        pvSeq++; pvLaeuft = false; state.pvFehler = false; state.masseUngueltig = true; renderLive(null);
        if (einfach) hinweis(zahlen.some(function (x) { return x > 3000; }) ? 'Teile über 3.000 mm Kantenlänge kalkulieren wir nicht im Formular – bitte schreiben Sie uns direkt.' : 'Bitte tragen Sie Maße größer als 0 mm ein.');
        return;
      }
      state.masseUngueltig = false;
      if (state.mode === 'print' && (!state.volumeCm3 || state.volumeCm3 <= 0)) { pvSeq++; pvLaeuft = false; state.pvFehler = false; renderLive(null); return; }
      var seq = ++pvSeq, body = JSON.stringify(techBody());
      if (einfach) { pvLaeuft = true; preisHinweis(); }
      var erst = kzErst; kzErst = false;
      fetch(api + '/api/quote/preview' + kz(erst), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (seq === pvSeq) { pvLaeuft = false; state.pvFehler = !(d && d.ok); if (d) d._sig = body; renderLive(d); } })
        .catch(function () { if (seq === pvSeq) { pvLaeuft = false; state.pvFehler = true; if (einfach) renderLive(null); } });
    }
    // Preis für GENAU den aktuellen Stand — die Live-Vorschau läuft 400 ms verzögert und kann nach einem
    // kurz darauf folgenden Klick (Staffel, Menge) noch von den alten Eingaben stammen.
    function previewJetzt() {
      var body = JSON.stringify(techBody());
      if (state.lastLive && state.lastLive._sig === body) return Promise.resolve(state.lastLive);
      if (!techFilled() || (state.mode === 'print' && (!state.volumeCm3 || state.volumeCm3 <= 0))) return Promise.resolve(null);
      return fetch(api + '/api/quote/preview', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
        .then(function (r) { return r.json(); })
        .then(function (d) { return d && d.ok ? d : null; })
        .catch(function () { return null; });
    }
    function schedulePreview() { if (pvTimer) clearTimeout(pvTimer); pvTimer = setTimeout(runPreview, 400); }

    var LIVE_FIELDS = ['lengthMm', 'widthMm', 'heightMm', 'quantity', 'material', 'surface', 'tolerance', 'express', 'process', 'printMaterial'];
    form.addEventListener('input', function (e) {
      if (e.target && LIVE_FIELDS.indexOf(e.target.name) >= 0) schedulePreview();
      if (einfach && e.target && /Mm$/.test(e.target.name || '')) { if (techFilled()) hinweis(state.dxfWarnung || ''); stufe(); }
    });
    form.addEventListener('change', function (e) { if (e.target && LIVE_FIELDS.indexOf(e.target.name) >= 0) schedulePreview(); });

    function val(name) { var el = (state.mode === 'print' ? printGroup : root).querySelector('[name="' + name + '"]'); if (!el) el = root.querySelector('[name="' + name + '"]'); return el ? el.value : ''; }
    function showErr(msg, ort) { var el = (ort === 'upload' && upErr) ? upErr : errEl; el.textContent = msg; el.hidden = false; }
    function clearErr() { root.querySelectorAll('.gw-qp-error').forEach(function (e) { e.hidden = true; }); }

    // ---- print material select ----
    function fillPrintMats() {
      var proc = (printGroup.querySelector('[name="process"]') || {}).value || 'FDM';
      var sel = printGroup.querySelector('[name="printMaterial"]');
      if (!sel) return;
      sel.innerHTML = PRINT_MATS[proc].map(function (m) { return '<option value="' + m[0] + '">' + m[1] + '</option>'; }).join('');
    }
    if (printGroup) {
      fillPrintMats();
      var procSel = printGroup.querySelector('[name="process"]');
      if (procSel) procSel.addEventListener('change', fillPrintMats);
    }

    // ---- mode toggle ----
    function setMode(m) {
      if (m === state.mode || no3d) return;
      if (einfach && root.hasAttribute('data-lesen')) return;
      if (einfach) upSeq++;
      state.mode = m;
      state.stepFile = null; state.drawingFile = null; state.stepName = null; state.drawingName = null; state.volumeCm3 = null; state.removalPct = null; state.holes = null; if (typeof docsZustand === 'function') docsZustand();
      if (state.stepLocal) { state.stepLocal = null; updateOpenBtn(); portalClear(); }
      root.querySelectorAll('.gw-qp-mode').forEach(function (b) { b.classList.toggle('gw-active', b.getAttribute('data-mode') === m); b.setAttribute('aria-pressed', b.getAttribute('data-mode') === m ? 'true' : 'false'); });
      var isPrint = m === 'print';
      if (cncGroup) cncGroup.hidden = isPrint;
      if (printGroup) printGroup.hidden = !isPrint;
      root.querySelectorAll('.gw-qp-fine-cnc').forEach(function (e) { e.hidden = isPrint; });
      root.querySelectorAll('.gw-qp-fine-print').forEach(function (e) { e.hidden = !isPrint; });
      // Im 3D-Druck gibt es keine Zeichnung: Die CAD-Karte nimmt dort STL,
      // die Zeichnungskarte blendet das CSS ueber [data-cnc-only] aus.
      var cadFeld = root.querySelector('.gw-qp-file[data-art="cad"]');
      if (cadFeld) cadFeld.setAttribute('accept', isPrint ? '.stl' : '.step,.stp,.stl');
      var cadTitel = root.querySelector('.gw-qp-doc[data-art="cad"] .gw-qp-doc-t');
      if (cadTitel) cadTitel.textContent = cadTitel.getAttribute(isPrint ? 'data-t-print' : 'data-t-cnc') || cadTitel.textContent;
      var cadFmt = root.querySelector('.gw-qp-doc[data-art="cad"] .gw-qp-doc-f');
      if (cadFmt) cadFmt.textContent = cadFmt.getAttribute(isPrint ? 'data-f-print' : 'data-f-cnc') || cadFmt.textContent;
      root.setAttribute('data-mode', m);
      if (labelEl) labelEl.textContent = labelEl.getAttribute(isPrint ? 'data-label-print' : 'data-label-cnc') || labelEl.textContent;
      if (einfach) {   // Moduswechsel = neuer Anfang: Maße und Sonderwege zurück, Ablagen passend zum Verfahren
        ['lengthMm', 'widthMm', 'heightMm'].forEach(function (n) { var el = q(n); if (el) el.value = ''; });
        state.manuell = false; state.beispiel = false; state.masse = ''; state.pvFehler = false; state.dxfWarnung = ''; hinweis('');
        var startFeld = root.querySelector('.gw-qp-file[data-art="alle"]');
        if (startFeld) startFeld.setAttribute('accept', isPrint ? '.stl,.step,.stp' : '.step,.stp,.stl,.pdf,.dxf,.png,.jpg,.jpeg');
        if (cadFeld) cadFeld.setAttribute('accept', isPrint ? '.stl,.step,.stp' : '.step,.stp,.stl');
        syncRadios();
      }
      resetDrop();
      renderLive(null); schedulePreview();
    }
    root.querySelectorAll('.gw-qp-mode').forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-mode')); }); });

    function resetDrop() {
      Array.prototype.forEach.call(root.querySelectorAll('.gw-qp-file'), function (f) { f.value = ''; });
      Array.prototype.forEach.call(root.querySelectorAll('.gw-qp-svc'), function (c) { c.checked = false; });
      if (typeof docsZustand === 'function') docsZustand();
      hidePreview();
    }

    // ---- file upload → extract ----
    // ── Unterlagen: zwei getrennte Ablagen (CAD + Zeichnung) ─────────────────
    var docsBox = root.querySelector('.gw-qp-docs');

    // Traegt den Zustand nach aussen: Das CSS schaltet daran den zutreffenden
    // Ergebnissatz scharf und hebt die noch leere Zeichnungskarte hervor.
    function docsZustand() {
      // Kommt die Datei doch, erledigt sich der Service-Wunsch — sonst landete ein unsichtbarer Haken in den Notizen.
      if (state.stepFile) { var sc = root.querySelector('.gw-qp-svc[data-svc="cad"]'); if (sc) sc.checked = false; }
      if (state.drawingFile) { var sd = root.querySelector('.gw-qp-svc[data-svc="drawing"]'); if (sd) sd.checked = false; }
      if (einfach) {   // „Wir modellieren“ gehört zur Zeichnung, „Wir erstellen die Zeichnung“ zum Modell
        if (!state.drawingFile) { var sc2 = root.querySelector('.gw-qp-svc[data-svc="cad"]'); if (sc2) sc2.checked = false; }
        if (!state.stepFile) { var sd2 = root.querySelector('.gw-qp-svc[data-svc="drawing"]'); if (sd2) sd2.checked = false; }
      }
      root.setAttribute('data-cad', state.stepFile ? '1' : '0');
      root.setAttribute('data-drawing', state.drawingFile ? '1' : '0');
      updateSubmitLabel();
      if (!docsBox) { stufe(); return; }
      docsBox.setAttribute('data-cad', state.stepFile ? '1' : '0');
      docsBox.setAttribute('data-drawing', state.drawingFile ? '1' : '0');
      [['cad', state.stepFile, state.stepName], ['drawing', state.drawingFile, state.drawingName]]
        .forEach(function (p) {
          var karte = docsBox.querySelector('.gw-qp-doc[data-art="' + p[0] + '"]');
          if (!karte) return;
          var zeile = karte.querySelector('.gw-qp-doc-file');
          var name = karte.querySelector('.gw-qp-doc-name');
          if (p[1]) {
            karte.setAttribute('data-da', '1');
            if (zeile) zeile.hidden = false;
            if (name) name.textContent = p[2] || 'Datei angehängt';
          } else {
            karte.removeAttribute('data-da');
            if (zeile) zeile.hidden = true;
          }
        });
      stufe();
    }

    // Eine Datei verarbeiten. Promise, damit mehrere NACHEINANDER laufen —
    // parallel wuerden sich Statusanzeige und Maszfelder ueberschreiben.
    var upSeq = 0, lesenAktiv = 0;   // „einfach“: jeder Neuanfang (Modus, Zurücksetzen, × Modell) macht laufende Uploads ungültig
    function verarbeite(file, karte) {
      var meinSeq = upSeq, warTeil = root.getAttribute('data-stufe') === 'teil', cadNeu = false, zeichnungNeu = false;
      var txt = karte ? karte.querySelector('.gw-qp-drop-txt') : null;
      var flaeche = karte ? karte.querySelector('.gw-qp-drop') : null;
      if (/\.stl$/i.test(file.name) && file.arrayBuffer) { state.stepLocal = null; updateOpenBtn(); portalClear(); file.arrayBuffer().then(function (buf) { showPreview({ arrayBuffer: buf }); }).catch(function () {}); }
      var istZeichnung = /\.(dxf|pdf|png|jpe?g)$/i.test(file.name);
      if (!istZeichnung) renderLive(null);   // neues Modell: alten Preis nicht neben den neuen Maßen stehen lassen
      if (einfach) {
        if (!lesenAktiv) { var ds = root.querySelector('.gw-qp-drop-start'); if (ds) ds.style.minHeight = ds.offsetHeight + 'px'; }   // Ablage springt nicht
        lesenAktiv++; root.setAttribute('data-lesen', ''); lesenAria(true);
        var bt = root.querySelector('.gw-qp-start-busy-t');
        if (bt) bt.textContent = istZeichnung ? 'Wir laden Ihre Zeichnung …' : 'Wir lesen Ihr Modell … Das dauert je nach Größe einige Sekunden.';
        if (!istZeichnung) ansage('Wir lesen Ihr Modell.');
      }
      if (txt) txt.textContent = istZeichnung ? 'Lade Zeichnung…' : 'Lese Geometrie…';
      if (flaeche) flaeche.classList.add('gw-qp-drop-busy');
      var fd = new FormData(); fd.append('file', file);
      var bsp = (file.__gwBeispiel || /^gw-beispiel/i.test(file.name || '')) && !(state && state.beispiel) ? '&bsp=1' : '';
      return fetch(api + '/api/quote/extract' + kz(false) + bsp, { method: 'POST', body: fd })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { d = d || {}; d._status = r.status; return d; }); })
        .then(function (d) {
          if (einfach && meinSeq !== upSeq) return;   // inzwischen neu angefangen: Ergebnis verwerfen
          if (d && d.success && /\.(step|stp)$/i.test(file.name)) {
            // anderes Teil ersetzt das bisherige: Viewer/anderer Tab sollen nicht mehr „liegt im Formular" sagen
            if (state.stepLocal && state.stepLocal !== file) portalClear();
            // Viewer auf derselben Seite zeigt „Ihr Teil" mit Messwerkzeugen
            document.dispatchEvent(new CustomEvent('gw:portal-file', { detail: { file: file } }));
            state.stepLocal = file; updateOpenBtn();   // Knopf „Im 3D-Viewer messen" in der Vorschau
          }
          if (d && d.success && d.fileKind === 'drawing') {
            state.drawingFile = d.drawingFile || null;
            state.drawingName = file.name;
            // Masze aus der Zeichnung nur, wenn nicht schon aus CAD bekannt —
            // die STEP-Geometrie ist die genauere Quelle.
            if (d.lengthMm && !state.stepFile) {
              root.querySelector('[name="lengthMm"]').value = d.lengthMm;
              root.querySelector('[name="widthMm"]').value = d.widthMm;
              root.querySelector('[name="heightMm"]').value = d.heightMm;
            }
            if (einfach) {
              zeichnungNeu = true;
              if (!state.stepFile) { state.masse = d.lengthMm ? 'dxf' : (state.masse || 'hand'); massHinweis(d); }
              ansage('Zeichnung angehängt: ' + file.name + '.');
            }
            // DXF-Befund (z. B. doppelte Kreise): einmal merken, jede neue Zeichnung ersetzt ihn. Mit STEP keine
            // Warnung — dann rechnet der Server mit den Bohrungen aus dem Modell, nicht aus der DXF.
            var alteW = state.dxfWarnung || '';
            state.dxfWarnung = (d.warnung && !state.stepFile) ? String(d.warnung) : '';
            var hh = root.querySelector('.gw-qp-hinweis');
            var sichtbar = hh && !hh.hidden ? (hh.textContent || '') : '';
            if (einfach && !state.stepFile) {   // massHinweis hat den Text eben neu gesetzt
              if (state.dxfWarnung) hinweis((sichtbar ? sichtbar + ' ' : '') + state.dxfWarnung);
            } else {
              var ohneAlt = alteW && sichtbar.indexOf(alteW) >= 0 ? sichtbar.replace(alteW, '').trim() : sichtbar;
              hinweis(state.dxfWarnung ? (ohneAlt ? ohneAlt + ' ' : '') + state.dxfWarnung : ohneAlt);
            }
            schedulePreview();
          } else if (d && d.success) {
            root.querySelector('[name="lengthMm"]').value = d.lengthMm;
            root.querySelector('[name="widthMm"]').value = d.widthMm;
            root.querySelector('[name="heightMm"]').value = d.heightMm;
            state.removalPct = d.removalPct != null ? d.removalPct : null;
            state.holes = d.holesCount != null ? d.holesCount : null;
            state.volumeCm3 = d.partVolCm3 != null ? d.partVolCm3 : null;
            state.stepFile = d.stepFile || null;
            state.stepName = file.name;
            dxfWarnungWeg();   // Modell liegt vor: die DXF-Bohrungen zählen nicht mehr
            if (einfach) {
              cadNeu = true;
              state.masse = 'modell'; state.manuell = false;
              // Beispielteil: markierte Datei aus „Beispielteil laden“ oder die öffentlichen Beispiele aus dem großen Viewer
              state.beispiel = !!file.__gwBeispiel || /^gw-beispiel/i.test(file.name || '');
              zeigGelesen(d); hinweis('');
              ansage((state.beispiel ? 'Beispielteil geladen. ' : '') + 'Modell gelesen: ' + zahl(d.lengthMm) + ' × ' + zahl(d.widthMm) + ' × ' + zahl(d.heightMm) + ' Millimeter.');
            }
            if (d.previewStl) showPreview({ url: api + '/api/quote/mesh?ref=' + encodeURIComponent(d.previewStl) });
            schedulePreview();
          } else {
            // 429/503/400 tragen deutsche Servertexte; 422/500 enthalten technische Rohtexte — dafür ein eigener Satz
            var st = d && d._status, belastet = st === 429 || st === 503 || st === 400;
            if (!einfach) {
              if (d && d.stepFile) {
                state.stepFile = d.stepFile; state.stepName = file.name;
                if (state.stepLocal && state.stepLocal !== file) { state.stepLocal = null; updateOpenBtn(); portalClear(); hidePreview(); }
              }
              showErr(belastet && d.error ? d.error : ('„' + file.name + '“ konnte nicht gelesen werden — bitte Maße manuell eintragen.'), 'upload');
              return;
            }
            if (belastet) {   // Zustand bleibt — die Ablage steht für den nächsten Versuch bereit
              showErr(d.error || 'Der Server ist gerade ausgelastet – bitte versuchen Sie es gleich noch einmal.', 'upload');
              if (!istZeichnung && state.stepFile) schedulePreview();
              return;
            }
            if (istZeichnung) { showErr('„' + file.name + '“ konnten wir nicht lesen. Bitte versuchen Sie es noch einmal, am besten als PDF.', 'upload'); return; }
            if (state.beispiel) beispielVerwerfen();
            if (state.stepFile) {   // bisheriges Modell behalten, nie alte Datei mit neuen Maßen mischen
              showErr('„' + file.name + '“ konnten wir nicht lesen – Ihr bisheriges Modell „' + state.stepName + '“ bleibt.', 'upload');
              schedulePreview();
              return;
            }
            if (state.mode === 'print') { showErr('„' + file.name + '“ konnten wir nicht lesen – bitte laden Sie Ihr 3D-Modell als STL oder STEP erneut hoch.', 'upload'); return; }
            showErr('„' + file.name + '“ konnten wir nicht lesen. Bitte tragen Sie die Außenmaße ein – dann rechnen wir ohne Modell.', 'upload');
            state.manuell = true; if (!state.masse || state.masse === 'modell') state.masse = 'hand';
          }
        })
        .catch(function () {
          if (einfach && meinSeq !== upSeq) return;
          showErr(einfach ? 'Upload von „' + file.name + '“ fehlgeschlagen – bitte versuchen Sie es gleich noch einmal.' : 'Upload von „' + file.name + '“ fehlgeschlagen — bitte Maße manuell eintragen.', 'upload');
          if (einfach && !istZeichnung && state.stepFile) schedulePreview();
        })
        .then(function () {
          if (flaeche) flaeche.classList.remove('gw-qp-drop-busy');
          if (txt) txt.textContent = txt.getAttribute('data-ruhe') || ((karte && karte.getAttribute('data-art') === 'drawing')
            ? 'Zeichnung ablegen oder auswählen' : 'Modell ablegen oder auswählen');
          if (einfach) {
            lesenAktiv = Math.max(0, lesenAktiv - 1);
            if (!lesenAktiv) { root.removeAttribute('data-lesen'); lesenAria(false); var ds2 = root.querySelector('.gw-qp-drop-start'); if (ds2) ds2.style.minHeight = ''; }
            if (meinSeq !== upSeq) return;
          }
          docsZustand();
          if (einfach && fokusWeg()) {   // der auslösende Knopf ist verschwunden: Fokus nicht auf body fallen lassen
            if (cadNeu && warTeil) fokus(root.querySelector('.gw-qp-teil-h'));
            else if (zeichnungNeu && root.getAttribute('data-stufe') === 'teil') fokus(root.querySelector('.gw-qp-doc[data-art="drawing"] .gw-qp-doc-x'));
          }
        });
    }

    // Jede Karte bekommt ihre eigene Ablage, ihr eigenes Feld und ihren eigenen
    // Loeschknopf — nur so ist fuer den Kunden sichtbar, welche der beiden
    // Unterlagen noch aussteht.
    Array.prototype.forEach.call(root.querySelectorAll('.gw-qp-doc, .gw-qp-start'), function (karte) {
      var art = karte.getAttribute('data-art');
      var feld = karte.querySelector('.gw-qp-file');
      var flaeche = karte.querySelector('.gw-qp-drop');
      if (!feld || !flaeche) return;

      flaeche.addEventListener('click', function () { if (einfach && root.hasAttribute('data-lesen')) return; feld.click(); });

      function annehmen(dateien) {
        if (!dateien || !dateien.length) return;
        try { feld.files = dateien; }
        catch (e) {
          try {
            var dt = new DataTransfer();
            for (var i = 0; i < dateien.length; i++) dt.items.add(dateien[i]);
            feld.files = dt.files;
          } catch (e2) {
            showErr(einfach ? 'Die Datei ließ sich nicht übernehmen. Bitte wählen Sie sie über „Dateien auswählen“ aus.' : 'Datei konnte nicht übernommen werden — bitte über Klick auswählen.', 'upload');
            return;
          }
        }
        feld.dispatchEvent(new Event('change', { bubbles: true }));
      }

      ['dragenter', 'dragover'].forEach(function (ev) {
        karte.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation();
          if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
          flaeche.classList.add('gw-qp-drag');
          if (einfach && flaeche.classList.contains('gw-qp-drop-start')) { var tm = flaeche.querySelector('.t-maus'); if (tm) tm.textContent = 'Loslassen zum Hochladen'; }
        });
      });
      ['dragleave', 'dragend'].forEach(function (ev) {
        karte.addEventListener(ev, function (e) {
          if (ev === 'dragleave' && e.relatedTarget && karte.contains(e.relatedTarget)) return;
          flaeche.classList.remove('gw-qp-drag');
          if (einfach) startTexte();
        });
      });
      karte.addEventListener('drop', function (e) {
        e.preventDefault(); e.stopPropagation();
        flaeche.classList.remove('gw-qp-drag');
        if (einfach) { startTexte(); if (root.hasAttribute('data-lesen')) return; }
        annehmen(e.dataTransfer && e.dataTransfer.files);
      });

      feld.addEventListener('change', function () {
        var liste = feld.files ? Array.prototype.slice.call(feld.files) : [];
        if (!liste.length) return;
        clearErr();
        if (einfach) { einsortieren(liste); feld.value = ''; return; }
        // Falsche Sorte in der falschen Ablage: nicht abweisen, sondern
        // stillschweigend richtig einsortieren — das Backend klassifiziert
        // ohnehin selbst, und ein Kunde soll an einer Ablage nicht scheitern.
        liste.reduce(function (kette, file) {
          var istZeichnung = /\.(dxf|pdf|png|jpe?g)$/i.test(file.name);
          var ziel = root.querySelector('.gw-qp-doc[data-art="' + (istZeichnung ? 'drawing' : 'cad') + '"]') || karte;
          return kette.then(function () { return verarbeite(file, ziel); });
        }, Promise.resolve());
      });

      var weg = karte.querySelector('.gw-qp-doc-x');
      if (weg) weg.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (art === 'drawing') { state.drawingFile = null; state.drawingName = null; dxfWarnungWeg(); }
        else {
          if (einfach) upSeq++;
          state.stepFile = null; state.stepName = null;
          state.removalPct = null; state.holes = null; state.volumeCm3 = null;
          state.stepLocal = null; updateOpenBtn(); portalClear();
          hidePreview();   // Vorschau gehört zur entfernten Datei — nicht stehen lassen
        }
        feld.value = '';
        if (einfach) {
          // Ohne Modell gelten die Serverwerte nicht mehr; aus einer DXF übernommene Maße gehen mit der Zeichnung
          if (art !== 'drawing' || (state.masse === 'dxf' && !state.stepFile)) {
            ['lengthMm', 'widthMm', 'heightMm'].forEach(function (n) { var el = q(n); if (el) el.value = ''; });
            state.masse = '';
          }
          if (art !== 'drawing') state.beispiel = false;
          hinweis('');
        }
        docsZustand();
        schedulePreview();
        if (einfach && root.getAttribute('data-stufe') === 'teil') fokus(karte.querySelector('.gw-qp-drop'));
      });
    });

    // Die beiden Serviceangebote schliessen einander aus: Wer beides ankreuzt,
    // hat weder Modell noch Zeichnung — dann ist es keine Sofortanfrage mehr.
    Array.prototype.forEach.call(root.querySelectorAll('.gw-qp-svc'), function (box) {
      box.addEventListener('change', function () {
        if (!box.checked) return;
        Array.prototype.forEach.call(root.querySelectorAll('.gw-qp-svc'), function (a) {
          if (a !== box) a.checked = false;
        });
      });
    });

    // ═════════ Variante „einfach“: erst die Datei, dann die Fragen ═════════
    // Gleiche Felder, gleiche API wie „klassisch“. Das Modul trägt nur den Zustand nach außen
    // (data-stufe, data-senden, data-masse …) — das CSS der Section blendet danach ein und aus.
    function q(n) { return root.querySelector('[name="' + n + '"]'); }
    function zahl(n) { return Number(n).toLocaleString('de-DE', { maximumFractionDigits: 1 }); }
    function kopfHoehe() { return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0; }
    function reduziert() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
    function fokus(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    // Ansagen nacheinander, jede bleibt mindestens 1,3 s stehen — sonst verdrängt „Zeichnung angehängt“ das „Modell gelesen“
    var ansageQ = [], ansageT = 0;
    function ansage(t) {
      if (!einfach || !srEl || !t || t === letzteAnsage || ansageQ.indexOf(t) >= 0) return;
      ansageQ.push(t); if (!ansageT) ansageWeiter();
    }
    function ansageWeiter() {
      var t = ansageQ.shift(); if (!t) { ansageT = 0; return; }
      letzteAnsage = t; srEl.textContent = '';
      setTimeout(function () { srEl.textContent = t; }, 60);
      ansageT = setTimeout(ansageWeiter, 1300);
      setTimeout(function () { if (letzteAnsage === t) letzteAnsage = ''; }, 5000);
    }
    function fokusWeg() { var a = document.activeElement; return !a || a === document.body || !a.getClientRects().length; }
    function startFokus() {   // Start-Ablage fokussieren und bei Bedarf ins Bild holen
      var d = root.querySelector('.gw-qp-drop-start'); if (!d) return;
      var r = d.getBoundingClientRect();
      if (r.top < kopfHoehe() || r.bottom > window.innerHeight) root.scrollIntoView({ block: 'start', behavior: reduziert() ? 'auto' : 'smooth' });
      fokus(d);
    }
    function lesenAria(an) {   // während des Lesens auch für Tastatur und Screenreader erkennbar gesperrt
      root.querySelectorAll('.gw-qp-drop-start, .gw-qp-weg, .gw-qp-start [data-weg], .gw-qp-mode').forEach(function (e) { if (an) e.setAttribute('aria-disabled', 'true'); else e.removeAttribute('aria-disabled'); });
    }
    function ungueltigWeg(x) {
      x.removeAttribute('aria-invalid');
      if (errEl && errEl.id) { var db = (x.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (t) { return t && t !== errEl.id; }).join(' '); if (db) x.setAttribute('aria-describedby', db); else x.removeAttribute('aria-describedby'); }
    }
    function beispielVerwerfen() {   // Beispielteil ganz entfernen (z. B. wenn das eigene Modell nicht lesbar war)
      state.stepFile = null; state.stepName = null; state.removalPct = null; state.holes = null; state.volumeCm3 = null;
      if (state.stepLocal) { state.stepLocal = null; updateOpenBtn(); portalClear(); }
      hidePreview();
      ['lengthMm', 'widthMm', 'heightMm'].forEach(function (n) { var el = q(n); if (el) el.value = ''; });
      state.beispiel = false; state.beispielDatei = null; state.masse = '';
    }
    function dxfWarnungWeg() {   // Warnung gehört zur Zeichnung: mit ihr (oder bei gelesenem Modell) verschwinden
      var hw = root.querySelector('.gw-qp-hinweis'), t = hw && !hw.hidden ? (hw.textContent || '') : '';
      if (state.dxfWarnung && t.indexOf(state.dxfWarnung) >= 0) hinweis(t.replace(state.dxfWarnung, '').trim());
      state.dxfWarnung = '';
    }
    function hinweis(t) { var h = root.querySelector('.gw-qp-hinweis'); if (!h) return; h.textContent = t || ''; h.hidden = !t; }
    function svcGesetzt() { var c = root.querySelector('.gw-qp-svc:checked'); return c ? c.getAttribute('data-svc') : ''; }

    function stufe() {
      if (!einfach) return;
      var alt = root.getAttribute('data-stufe');
      var neu = (techEmpty() && !state.manuell) ? (state.parts.length ? 'weiteres' : 'leer') : 'teil';
      root.setAttribute('data-stufe', neu);
      root.setAttribute('data-senden', (state.parts.length || state.lastLive || (techFilled() && state.pvFehler && !state.masseUngueltig)) ? '1' : '0');
      root.setAttribute('data-teile', state.parts.length ? '1' : '0');
      if (state.beispiel) root.setAttribute('data-beispiel', ''); else root.removeAttribute('data-beispiel');
      root.setAttribute('data-masse', state.masse || '');
      var sv = svcGesetzt(); if (sv) root.setAttribute('data-svc', sv); else root.removeAttribute('data-svc');
      startTexte(); basis(); preisHinweis(); wegSatz(); barPruefen();
      if (neu === 'teil' && alt !== 'teil') ankommen();
      else if (neu !== 'teil' && alt === 'teil') startFokus();
    }
    function ankommen() {   // nach dem Wechsel zu „teil“: Fokus setzen, nur scrollen, wenn das Werkzeug schlecht liegt
      var leer = ['lengthMm', 'widthMm', 'heightMm'].map(q).filter(function (e) { return e && !e.value; })[0];
      var ziel = (state.masse !== 'modell' && leer) ? leer : root.querySelector('.gw-qp-teil-h');
      if (ziel && /Mm$/.test(ziel.name || '')) {   // Maßfeld sichtbar machen, nicht unter Kopfzeile oder schwebenden Knöpfen
        var rz = ziel.getBoundingClientRect();
        if (rz.top < kopfHoehe() + 8 || rz.bottom > window.innerHeight - 120) (root.querySelector('.gw-qp-masse') || ziel).scrollIntoView({ block: 'center', behavior: reduziert() ? 'auto' : 'smooth' });
        fokus(ziel); return;
      }
      var top = root.getBoundingClientRect().top;
      if (top < kopfHoehe() || top > window.innerHeight * 0.3) root.scrollIntoView({ block: 'start', behavior: reduziert() ? 'auto' : 'smooth' });
      fokus(ziel);
    }
    function startTexte() {
      var print = state.mode === 'print', weiter = root.getAttribute('data-stufe') === 'weiteres' && !print;
      root.querySelectorAll('.gw-qp-start [data-t-cnc]').forEach(function (e) {
        var t = (weiter && e.getAttribute('data-t-weiter')) || e.getAttribute(print ? 'data-t-print' : 'data-t-cnc');
        if (t && e.textContent !== t) e.textContent = t;
      });
      var d = root.querySelector('.gw-qp-drop-start'); if (d) d.setAttribute('aria-label', d.getAttribute(print ? 'data-aria-print' : 'data-aria-cnc'));
    }
    function ausfKurz() {   // Abweichungen von der Standardausführung, für „Gerechnet nach …“
      if (!cncGroup) return 'Standardausführung';
      var t = cncGroup.querySelector('[name="tolerance"]').value, s = cncGroup.querySelector('[name="surface"]').value, teile = [];
      if (t === 'tight') teile.push('Toleranz eng (±0,05 mm)'); else if (t === 'precision') teile.push('Feinstbereich');
      if (s !== 'as_machined') teile.push(selText(cncGroup, 'surface').toLowerCase());
      return teile.length ? teile.join(', ') : 'Standardausführung';
    }
    function basis() {
      var el = root.querySelector('.gw-qp-basis'), t = root.querySelector('.gw-qp-basis-t'); if (!el || !t) return;
      if (!state.lastLive) { el.hidden = true; return; }
      var sv = svcGesetzt(), txt;
      if (state.mode === 'print') txt = 'Gerechnet nach: Volumen und Maßen Ihres Modells';
      else if (state.beispiel) txt = 'Gerechnet nach: Beispielteil · ' + ausfKurz();
      else if (state.stepFile) txt = 'Gerechnet nach: Ihrem Modell · ' + ausfKurz() + ' · ' + (state.drawingFile ? 'Zeichnung liegt bei' : sv === 'drawing' ? 'Zeichnung erstellen wir' : 'ohne Zeichnung');
      else if (state.drawingFile) txt = 'Gerechnet nach: Ihren Außenmaßen · Zeichnung liegt bei · ' + (sv === 'cad' ? 'Modell erstellen wir' : 'ohne Modell');
      else txt = 'Gerechnet nach: Ihren Außenmaßen · ohne Modell und Zeichnung';
      t.textContent = txt; el.hidden = false;
    }
    function preisHinweis() {
      if (!einfach || !hintEl) return;
      hintEl.textContent = root.getAttribute('data-stufe') === 'weiteres' ? 'Legen Sie das nächste Teil ab – oder senden Sie die Anfrage ab.'
        : (state.pvFehler && techFilled() && !state.masseUngueltig) ? 'Den Preis konnten wir gerade nicht berechnen. Sie können die Anfrage trotzdem senden – wir melden uns binnen 24 Stunden.'
        : pvLaeuft ? 'Ihr Preis wird berechnet …'
        : (state.mode === 'print' && techFilled() && !state.volumeCm3) ? 'Für den 3D-Druck-Preis brauchen wir das 3D-Modell (STL oder STEP) – daraus lesen wir das Volumen.'
        : 'Ihr Preis erscheint hier, sobald Länge, Breite und Höhe feststehen.';
    }
    var WEG_SATZ = {
      auto: 'Ihr Angebot mit Bestell-Link erscheint direkt hier und kommt zusätzlich per E-Mail.',
      drawing: 'Wir lesen Ihre Zeichnung beim Absenden mit. Das Ergebnis erscheint direkt hier und kommt zusätzlich per E-Mail.',
      manual: 'Wir kalkulieren von Hand. Ihr Angebot kommt binnen 24 Stunden per E-Mail.',
      open: 'Wir melden uns binnen 24 Stunden per E-Mail.'
    };
    function wegSatz() { var el = root.querySelector('.gw-qp-weg-satz'); if (el) el.textContent = WEG_SATZ[submitWeg().key] || ''; }
    function grund() {   // genau EIN Grund für die Prüfung, nur aus den eigenen Eingaben (Schwellen wie in der Engine)
      var b = techBody(), print = state.mode === 'print';
      var m = [b.lengthMm, b.widthMm, b.heightMm].map(Number).sort(function (x, y) { return y - x; });
      if (b.express) return 'Eilaufträge planen wir von Hand ein.';
      if (!print && b.tolerance === 'precision') return 'Den Feinstbereich prüfen wir immer von Hand.';
      if (b.quantity > (print ? 50 : 20)) return print ? 'Ab 51 Stück kalkulieren wir von Hand.' : 'Ab 21 Stück kalkulieren wir von Hand.';
      if (!print && m[0] > 650) return 'Bei Teilen über 650 mm Kantenlänge prüfen wir Verpackung und Versand von Hand.';
      if (!print && /^anodized/.test(b.surface || '') && !/^alu_/.test(b.material || '')) return 'Eloxieren geht nur bei Aluminium – die Oberfläche klären wir mit Ihnen.';
      if (!print && !state.stepFile && (m[0] / 10) * (m[1] / 10) >= 400) return 'Ohne Modell kennen wir die Bohrungen nicht. Legen Sie Ihr Modell ab, dann rechnen wir neu.';
      return print ? 'Das kann an Größe, Verfahren oder Auftragswert liegen.' : 'Das kann an der Bauform (etwa Dreh- oder Blechteil), am Gewicht oder an einem Auftragswert über 500 € netto liegen.';
    }
    function nachLive(d) {
      if (!einfach) return;
      if (d && d.ok && !d.autoQuote && liveEl && state.beispiel) {   // Beispielteil: nichts versprechen, was man hier nicht absenden kann
        var subB = liveEl.querySelector('.gw-qp-live-sub');
        if (subB) subB.textContent = 'So ein Teil würden wir von Hand kalkulieren.';
        if (subB) subB.insertAdjacentHTML('afterend', '<span class="gw-qp-live-grund">' + esc(grund()) + '</span>');
      } else if (d && d.ok && !d.autoQuote && liveEl) {
        var sub = liveEl.querySelector('.gw-qp-live-sub'), extra = '<span class="gw-qp-live-grund">' + esc(grund()) + '</span>';
        var auto = (d.tiers || []).filter(function (x) { return x.auto !== false && x.unitNet != null; });
        if (auto.length >= 2) extra += '<span class="gw-qp-live-note">Bis ' + auto[auto.length - 1].qty + ' Stück gibt es einen Sofortpreis – siehe Staffel.</span>';
        if (state.mode !== 'print' && !state.drawingFile) extra += '<span class="gw-qp-live-note">Legen Sie die Zeichnung dazu – sie ist unsere Grundlage für die Prüfung.</span>';
        if (sub) sub.insertAdjacentHTML('afterend', extra);
      }
      var key = d && d.ok ? (d.autoQuote ? 'p' + d.vkOrderNet : 'm') : '';
      if (key && key !== letzterPreis) {
        ansage(d.autoQuote ? 'Sofortpreis: ' + eur(d.vkOrderNet) + ' netto für ' + techBody().quantity + ' Stück.' : state.beispiel ? 'Individuelle Prüfung.' : 'Individuelle Prüfung. Ihr Angebot kommt binnen 24 Stunden.');
      }
      letzterPreis = key;
      stufe();
    }
    function zeigGelesen(d) {
      var box = root.querySelector('.gw-qp-geo'); if (!box) return;
      var li = [];
      if (d.lengthMm) li.push('Hüllmaße ' + zahl(d.lengthMm) + ' × ' + zahl(d.widthMm) + ' × ' + zahl(d.heightMm) + ' mm');
      if (d.partVolCm3 != null) li.push('Volumen ' + zahl(d.partVolCm3) + ' cm³');
      if (state.mode !== 'print') {
        if (d.removalPct != null) li.push('Zerspanvolumen ' + zahl(d.removalPct) + ' % des Hüllquaders');
        if (d.holesCount > 0) li.push('Anzahl der Bohrungen: ' + d.holesCount);
      }
      box.querySelector('ul').innerHTML = li.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
      box.hidden = !li.length;
    }
    function massHinweis(d) {
      if (!d.lengthMm) hinweis('Ihre Zeichnung liegt vor. Aus PDF- und Bilddateien lesen wir die Maße nicht automatisch – bitte tragen Sie Länge, Breite und Höhe ein.');
      else if (!d.heightMm) hinweis('Länge und Breite haben wir aus der DXF übernommen – bitte ergänzen Sie die Höhe.');
      else hinweis('Maße aus Ihrer DXF übernommen – bitte prüfen.');
    }
    var MAX_BYTES = 30 * 1024 * 1024;
    function einsortieren(liste) {   // eine Ablage für alles: höchstens 1 Modell + 1 Zeichnung je Teil, Prüfung schon im Browser
      var print = state.mode === 'print', modell = null, zeichnung = null, mehrM = false, mehrZ = false, zHinweis = false;
      liste.forEach(function (f) {
        var n = f.name || '';
        var istM = /\.(step|stp|stl)$/i.test(n), istZ = /\.(pdf|dxf|png|jpe?g)$/i.test(n);
        if (print && istZ) { zHinweis = true; return; }
        if (!istM && !istZ) { showErr('„' + n + '“ können wir nicht lesen. ' + (print ? '3D-Modelle bitte als STL oder STEP.' : 'Modelle bitte als STEP oder STP, Zeichnungen als PDF, DXF, PNG oder JPG.'), 'upload'); return; }
        if (f.size > MAX_BYTES) { showErr('„' + n + '“ ist größer als 30 MB – bitte als kleinere Datei exportieren.', 'upload'); return; }
        if (istM) { if (modell) mehrM = true; else modell = f; } else { if (zeichnung) mehrZ = true; else zeichnung = f; }
      });
      var h = [];
      if (zHinweis) h.push('Im 3D-Druck rechnen wir nur mit dem 3D-Modell (STL oder STEP). Hinweise aus Ihrer Zeichnung nennen Sie nach dem Upload in den Anmerkungen.');
      if (mehrM) h.push('Bitte ein Teil nach dem anderen: Wir haben „' + modell.name + '“ übernommen. Weitere Modelle legen Sie über „Weiteres Teil hinzufügen“ ab.');
      if (mehrZ) h.push('Pro Teil nehmen wir eine Zeichnung: „' + zeichnung.name + '“ ist angehängt.');
      var auftrag = [];
      if (modell) auftrag.push([modell, 'cad']);
      if (zeichnung) auftrag.push([zeichnung, 'drawing']);
      var seq0 = upSeq;
      function zeigH() {
        if (!h.length) return;
        if (root.getAttribute('data-stufe') !== 'teil') { showErr(h.join(' '), 'upload'); return; }
        var el = root.querySelector('.gw-qp-hinweis'), alt = el && !el.hidden ? el.textContent : '';
        hinweis([alt].concat(h).filter(Boolean).join(' '));
      }
      auftrag.reduce(function (kette, a) {
        return kette.then(function () { if (seq0 !== upSeq) return; return verarbeite(a[0], root.querySelector('.gw-qp-doc[data-art="' + a[1] + '"]')); });
      }, Promise.resolve()).then(function () { if (seq0 === upSeq) zeigH(); });
      if (!auftrag.length) zeigH();
    }
    var bspLaedt = false;
    function ladeBeispiel() {
      if (bspLaedt || root.hasAttribute('data-lesen')) return;
      bspLaedt = true; clearErr();
      fetch(api + '/samples/gw-beispielteil.step')
        .then(function (r) { if (!r.ok) throw new Error('http'); return r.blob(); })
        .then(function (b) {
          var f = new File([b], 'gw-beispielteil.step', { type: 'application/octet-stream' });
          f.__gwBeispiel = true; state.beispielDatei = f;
          return verarbeite(f, root.querySelector('.gw-qp-doc[data-art="cad"]'));
        })
        .catch(function () { showErr('Das Beispielteil lässt sich gerade nicht laden. Bitte versuchen Sie es später noch einmal.', 'upload'); })
        .then(function () { bspLaedt = false; });
    }

    // Aufklapper: ein Handler für alle [data-auf], Zustand bei Bedarf gemerkt
    function aufklappen(btn, auf) {
      if (!btn) return;
      if (auf === undefined) auf = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', auf ? 'true' : 'false');
      (btn.getAttribute('aria-controls') || '').split(/\s+/).forEach(function (id) { var el = id && document.getElementById(id); if (el) el.hidden = !auf; });
      var alt = btn.getAttribute('data-alt');
      if (alt) { if (!btn.hasAttribute('data-txt')) btn.setAttribute('data-txt', btn.textContent); btn.textContent = auf ? alt : btn.getAttribute('data-txt'); }
      var m = btn.getAttribute('data-merken'); if (m) { try { localStorage.setItem(m, auf ? '1' : '0'); } catch (e) {} }
      if (auf && btn.hasAttribute('data-einmal')) btn.hidden = true;
    }
    function kontaktAuto() {   // Telefon/Anmerkungen öffnen sich dort, wo sie fachlich gebraucht werden
      var t = root.getAttribute('data-tol');
      if (((t === 'tight' || t === 'precision') && !state.drawingFile) || svcGesetzt()) aufklappen(root.querySelector('.gw-qp-mehr-btn'), true);
    }
    // Auswahlkacheln (Radios) schreiben in die versteckten Auswahlfelder — techBody() liest unverändert
    function syncRadios() {
      if (!einfach) return;
      root.querySelectorAll('input[type="radio"][name$="_ui"]').forEach(function (r) {
        var sel = root.querySelector('select[name="' + r.name.replace(/_ui$/, '') + '"]');
        r.checked = !!sel && sel.value === r.value;
      });
      eloxalRegel();
    }
    function ausfText() {
      if (!einfach || !cncGroup) return;
      var t = cncGroup.querySelector('[name="tolerance"]').value, s = cncGroup.querySelector('[name="surface"]').value;
      root.setAttribute('data-tol', t);
      var sum = root.querySelector('.gw-qp-ausf-sum');
      if (sum) sum.textContent = (t === 'tight' ? 'Eng ±0,05 mm' : t === 'precision' ? 'Feinstbereich' : 'Standard · ISO 2768-m') + ' · ' + (s === 'as_machined' ? 'wie gefertigt' : selText(cncGroup, 'surface').toLowerCase());
      if (t !== 'standard' || s !== 'as_machined') { var ab = root.querySelector('.gw-qp-ausf-btn'); if (ab && ab.getAttribute('aria-expanded') !== 'true') aufklappen(ab, true); }
      kontaktAuto(); basis();
    }
    function eloxalRegel() {   // Eloxieren geht nur bei Aluminium (die Engine rechnet sonst von Hand, seit 26.09.)
      if (!einfach || !cncGroup) return;
      var mat = (cncGroup.querySelector('[name="material"]') || {}).value || '', alu = /^alu_/.test(mat);
      var sel = cncGroup.querySelector('[name="surface"]'); if (!sel) return;
      var war = /^anodized/.test(sel.value);
      Array.prototype.forEach.call(sel.options, function (o) { if (/^anodized/.test(o.value)) o.disabled = !alu; });
      root.querySelectorAll('input[name="surface_ui"]').forEach(function (r) { if (/^anodized/.test(r.value)) r.disabled = !alu; });
      var el = root.querySelector('.gw-qp-elox');
      if (war && !alu) {
        sel.value = 'as_machined';
        root.querySelectorAll('input[name="surface_ui"]').forEach(function (r) { r.checked = r.value === 'as_machined'; });
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        if (el) { el.textContent = 'Eloxieren geht nur bei Aluminium – Oberfläche auf „wie gefertigt“ gestellt.'; el.hidden = false; }
      } else if (el && alu) el.hidden = true;
      ausfText();
    }
    var matSel = cncGroup ? cncGroup.querySelector('[name="material"]') : null;
    if (matSel && einfach) matSel.addEventListener('change', eloxalRegel);

    // Handy-Preisleiste (steht außerhalb von .gw-qp)
    var bar = einfach ? ((root.closest('.gw-quote') || document).querySelector('.gw-qp-bar')) : null;
    var mq = window.matchMedia ? window.matchMedia('(max-width: 899px)') : null;
    var werkzeugSicht = false, sumSicht = false, eingabeFokus = false;
    function barPruefen() {
      if (!bar) return;
      var L = state.lastLive, nurListe = state.parts.length && techEmpty();
      var an = !!(mq && mq.matches && !form.hidden && !state.beispiel && !form.hasAttribute('aria-busy') && (L || state.parts.length) && werkzeugSicht && !sumSicht && !eingabeFokus);
      if (an) {
        var s1, s2, k = 'Zur Anfrage';
        if (L && L.autoQuote && !nurListe) { s1 = eur(L.vkOrderNet) + ' netto'; s2 = techBody().quantity + ' Stk.'; k = 'Zum Angebot'; }
        else if (L && !nurListe) { s1 = 'Individuelle Prüfung'; s2 = 'Angebot binnen 24 Stunden'; }
        else { var sm = partsSum ? partsSum.textContent : ''; s1 = state.parts.length + (state.parts.length === 1 ? ' Teil' : ' Teile'); s2 = (sm && sm !== '—') ? 'Zwischensumme ' + sm + ' netto' : 'Angebot binnen 24 Stunden'; }
        bar.querySelector('.gw-qp-bar-info strong').textContent = s1;
        bar.querySelector('.gw-qp-bar-info span').textContent = s2;
        bar.querySelector('.gw-qp-bar-go').textContent = k;
      }
      bar.hidden = !an;
      document.documentElement.classList.toggle('gw-qp-bar-an', an);
      if (an) {
        document.documentElement.style.setProperty('--qp-bar-h', bar.offsetHeight + 'px');
        var ae = document.activeElement;   // fokussiertes Element nicht unter der Leiste verschwinden lassen (WCAG 2.4.11)
        if (ae && root.contains(ae)) { var ra = ae.getBoundingClientRect(), tb = bar.getBoundingClientRect().top; if (ra.bottom > tb) window.scrollBy(0, ra.bottom - tb + 12); }
      }
    }
    if (bar) {
      var sumEl = root.querySelector('.gw-qp-col-sum');
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (x) { if (x.target === root) werkzeugSicht = x.isIntersecting; else sumSicht = x.isIntersecting; });
          barPruefen();
        });
        io.observe(root); if (sumEl) io.observe(sumEl);
      }
      var tastaturFeld = function (el) { return /^(SELECT|TEXTAREA)$/.test(el.tagName) || (el.tagName === 'INPUT' && !/^(checkbox|radio|file)$/.test(el.type)); };
      root.addEventListener('focusin', function (e) { if (tastaturFeld(e.target)) { eingabeFokus = true; barPruefen(); } });
      root.addEventListener('focusout', function (e) { if (tastaturFeld(e.target)) { eingabeFokus = false; setTimeout(barPruefen, 50); } });
      if (mq && mq.addEventListener) mq.addEventListener('change', barPruefen);
      bar.querySelector('.gw-qp-bar-go').addEventListener('click', function () {
        var k = root.querySelector('.gw-qp-kontakt');
        if (k) k.scrollIntoView({ block: 'start', behavior: reduziert() ? 'auto' : 'smooth' });   // scroll-margin-top im CSS
        var leer = ['customerName', 'email'].map(q).filter(function (e) { return e && !e.value.trim(); })[0];
        setTimeout(function () { fokus(leer || submitBtn); }, reduziert() ? 0 : 350);
      });
    }

    if (einfach) {
      // Klicks auf Wege, Aufklapper, Service-Knöpfe
      root.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target : null; if (!t) return;
        var auf = t.closest('[data-auf]');
        if (auf && root.contains(auf)) {
          e.preventDefault();
          var war = auf.getAttribute('aria-expanded') === 'true';
          aufklappen(auf);
          if (!war && auf.hasAttribute('data-einmal')) {
            var ziel = document.getElementById((auf.getAttribute('aria-controls') || '').split(/\s+/)[0]);
            fokus(ziel && ziel.querySelector('input, textarea, select'));
          }
          return;
        }
        var w = t.closest('[data-weg]');
        if (w && root.contains(w)) {
          var weg = w.getAttribute('data-weg');
          if (root.hasAttribute('data-lesen') && weg !== 'anmerkung') return;
          if (weg === 'zeichnung') { var fz = root.querySelector('.gw-qp-file[data-art="drawing"]'); if (fz) fz.click(); }
          else if (weg === 'eigen') { var fc = root.querySelector('.gw-qp-file[data-art="cad"]'); if (fc) fc.click(); }
          else if (weg === 'masse') { state.manuell = true; if (!state.masse) state.masse = 'hand'; stufe(); }
          else if (weg === 'beispiel') ladeBeispiel();
          else if (weg === 'anmerkung') { aufklappen(root.querySelector('.gw-qp-mehr-btn'), true); fokus(q('notes')); }
          return;
        }
        if (t.closest('.gw-qp-svc-an')) { var sd = root.querySelector('.gw-qp-svc[data-svc="drawing"]'); if (sd && !sd.checked) { sd.checked = true; sd.dispatchEvent(new Event('change', { bubbles: true })); } fokus(root.querySelector('.gw-qp-svc-aus')); return; }
        if (t.closest('.gw-qp-svc-aus')) { var sa = root.querySelector('.gw-qp-svc[data-svc="drawing"]'); if (sa && sa.checked) { sa.checked = false; sa.dispatchEvent(new Event('change', { bubbles: true })); } fokus(root.querySelector('.gw-qp-svc-an')); return; }
        if (t.closest('.gw-qp-neu')) { resetTech(); stufe(); }
      });
      root.addEventListener('change', function (e) {
        var r = e.target; if (!r) return;
        if (r.type === 'radio' && /_ui$/.test(r.name)) {
          var sel = root.querySelector('select[name="' + r.name.replace(/_ui$/, '') + '"]');
          if (sel) { sel.value = r.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          ausfText();
        } else if (r.classList && r.classList.contains('gw-qp-svc')) { stufe(); kontaktAuto(); }
      });
      // Enter sendet nicht versehentlich ab (nur in den Kontaktfeldern); in den Maßfeldern weiter zum nächsten leeren
      form.addEventListener('input', function (e) { if (e.target && e.target.getAttribute && e.target.getAttribute('aria-invalid')) ungueltigWeg(e.target); });
      form.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var t = e.target; if (!t || t.tagName !== 'INPUT' || t.closest('.gw-qp-kontakt')) return;
        e.preventDefault();
        if (/Mm$/.test(t.name || '')) { var n = ['lengthMm', 'widthMm', 'heightMm'].map(q).filter(function (x) { return x && x !== t && !x.value; })[0]; if (n) fokus(n); }
      });
      root.querySelectorAll('[data-merken]').forEach(function (b) { var v = null; try { v = localStorage.getItem(b.getAttribute('data-merken')); } catch (e) {} if (v === '1') aufklappen(b, true); });
      root.querySelectorAll('.gw-qp-mode').forEach(function (b) { b.setAttribute('aria-pressed', b.classList.contains('gw-active') ? 'true' : 'false'); });
      var modes = root.querySelector('.gw-qp-modes'); if (modes) { modes.setAttribute('role', 'group'); modes.setAttribute('aria-label', 'Fertigungsverfahren'); }
      syncRadios();
    }
    docsZustand();
    // Mitlaufende Preisspalte: Höhe bis einschließlich Absendeknopf (das Kleingedruckte darunter darf
    // aus dem Bild laufen). Passt das nicht unter die Kopfzeile, klebt die Spalte so, dass der Knopf sichtbar bleibt.
    var sumCol = root.querySelector('.gw-qp-col-sum');
    if (sumCol && submitBtn && window.ResizeObserver) {
      var bisKnopf = function () { sumCol.style.setProperty('--qp-sum-h', Math.round(submitBtn.getBoundingClientRect().bottom - sumCol.getBoundingClientRect().top + 8) + 'px'); };
      new ResizeObserver(bisKnopf).observe(sumCol);
      window.addEventListener('resize', bisKnopf);
    }
    // Übergabe aus dem STEP-Viewer (gleiche Seite): Datei landet in der CAD-Karte,
    // als hätte der Kunde sie hier abgelegt.
    document.addEventListener('gw:handoff', function (ev) {
      var f = ev && ev.detail && ev.detail.file; if (!f) return;
      ev.preventDefault();
      var karte = root.querySelector('.gw-qp-doc[data-art="cad"]');
      if (state.mode !== 'cnc') { var cncBtn = root.querySelector('[data-mode="cnc"]'); if (cncBtn) cncBtn.click(); }
      verarbeite(f, karte);
    });

    // ---- Mehrteile-Warenkorb ----
    function techFilled() {
      return root.querySelector('[name="lengthMm"]').value && root.querySelector('[name="widthMm"]').value && root.querySelector('[name="heightMm"]').value;
    }
    function techEmpty() {
      return !root.querySelector('[name="lengthMm"]').value && !root.querySelector('[name="widthMm"]').value && !root.querySelector('[name="heightMm"]').value && !state.stepFile && !state.drawingFile;
    }
    function collectTech() {
      var qtyEl = (state.mode === 'print' ? printGroup : cncGroup).querySelector('[name="quantity"]');
      var p = {
        lengthMm: root.querySelector('[name="lengthMm"]').value,
        widthMm: root.querySelector('[name="widthMm"]').value,
        heightMm: root.querySelector('[name="heightMm"]').value,
        quantity: Number(qtyEl && qtyEl.value) || 1,
        express: !!root.querySelector('[name="express"]').checked,
        stepFile: state.stepFile,
        drawingFile: state.drawingFile
      };
      if (state.mode === 'print') {
        p.kind = 'print';
        p.process = printGroup.querySelector('[name="process"]').value;
        p.material = printGroup.querySelector('[name="printMaterial"]').value;
        p.volumeCm3 = state.volumeCm3;
      } else {
        p.material = cncGroup.querySelector('[name="material"]').value;
        p.surface = cncGroup.querySelector('[name="surface"]').value;
        p.tolerance = cncGroup.querySelector('[name="tolerance"]').value;
        p.removalPct = state.removalPct;
        p.holes = state.holes;
      }
      return p;
    }
    function validateTech() {
      if (!techFilled()) return einfach ? 'Bitte tragen Sie Länge, Breite und Höhe ein – oder legen Sie ein Modell ab.' : 'Maße erforderlich (oder Datei hochladen).';
      if (einfach) {
        var mz = ['lengthMm', 'widthMm', 'heightMm'].map(function (n) { return Number(q(n).value); });
        if (mz.some(function (x) { return !(x > 0); })) return 'Bitte tragen Sie Maße größer als 0 mm ein.';
        if (mz.some(function (x) { return x > 3000; })) return 'Teile über 3.000 mm Kantenlänge kalkulieren wir nicht im Formular – bitte schreiben Sie uns direkt.';
      }
      if (state.mode === 'print' && (!state.volumeCm3 || state.volumeCm3 <= 0)) return einfach ? 'Für den 3D-Druck-Preis brauchen wir das 3D-Modell (STL oder STEP) – daraus lesen wir das Volumen.' : 'Für 3D-Druck bitte eine STL/STEP hochladen — wir brauchen das Volumen für den Preis.';
      return null;
    }
    function selText(group, name) {
      var sel = group && group.querySelector('[name="' + name + '"]');
      return sel && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex].text : '';
    }
    function partLabel(p) {
      var mat = p.kind === 'print'
        ? (p.process + ' · ' + selText(printGroup, 'printMaterial'))
        : selText(cncGroup, 'material');
      var datei = einfach && state.stepName ? state.stepName + (state.drawingFile ? ' + Zeichnung' : '') + ' · ' : (einfach && state.drawingFile ? (state.drawingName || 'Zeichnung') + ' · ' : '');
      return p.quantity + ' Stk. · ' + datei + mat + ' · ' + p.lengthMm + '×' + p.widthMm + '×' + p.heightMm + ' mm';
    }
    function resetTech() {
      state.manuell = false; state.beispiel = false; state.beispielDatei = null; state.masse = ''; state.pvFehler = false; state.masseUngueltig = false;
      state.dxfWarnung = '';
      if (einfach) { upSeq++; hinweis(''); clearErr(); }
      ['lengthMm', 'widthMm', 'heightMm'].forEach(function (n) { var el = root.querySelector('[name="' + n + '"]'); if (el) el.value = ''; });
      var ex = root.querySelector('[name="express"]'); if (ex) ex.checked = false;
      state.stepFile = null; state.drawingFile = null; state.stepName = null; state.drawingName = null; state.volumeCm3 = null; state.removalPct = null; state.holes = null; if (typeof docsZustand === 'function') docsZustand();
      if (state.stepLocal) { state.stepLocal = null; updateOpenBtn(); portalClear(); }
      if (pvTimer) { clearTimeout(pvTimer); pvTimer = null; }
      pvSeq++;   // Antwort, die noch unterwegs ist, gehört zum alten Teil
      resetDrop(); renderLive(null);
    }
    function renderParts() {
      if (!partsWrap || !partsList) return;
      if (state.parts.length === 0) { partsWrap.hidden = true; partsList.innerHTML = ''; updateSubmitLabel(); stufe(); return; }
      partsWrap.hidden = false;
      partsList.innerHTML = state.parts.map(function (p, i) {
        var price = p._auto === false
          ? '<em>manuelle Prüfung</em>'
          : (p._price != null ? esc(eur(p._price)) + ' <em>netto</em>' : '—');
        return '<div class="gw-qp-part">' +
          '<span class="gw-qp-part-n">' + (i + 1) + '</span>' +
          '<span class="gw-qp-part-lbl">' + esc(p._label) + '</span>' +
          '<span class="gw-qp-part-price">' + price + '</span>' +
          '<button type="button" class="gw-qp-part-x" data-i="' + i + '" aria-label="Teil entfernen">×</button></div>';
      }).join('');
      var known = state.parts.filter(function (p) { return p._price != null && p._auto !== false; });
      if (partsSum) {
        partsSum.textContent = known.length === state.parts.length
          ? eur(known.reduce(function (s, p) { return s + Number(p._price); }, 0))
          : (known.length ? 'ab ' + eur(known.reduce(function (s, p) { return s + Number(p._price); }, 0)) : '—');
      }
      partsList.querySelectorAll('.gw-qp-part-x').forEach(function (b) {
        b.addEventListener('click', function () {
          var ix = Number(b.getAttribute('data-i'));
          state.parts.splice(ix, 1);
          renderParts();
          if (einfach) { var xs = partsList.querySelectorAll('.gw-qp-part-x'); if (xs.length) fokus(xs[Math.min(ix, xs.length - 1)]); else if (fokusWeg()) startFokus(); }
        });
      });
      updateSubmitLabel();
      stufe();
    }
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        clearErr();
        var err = validateTech();
        if (err) { showErr(err); return; }
        if (addBtn.disabled) return;
        if (einfach && state.beispiel) { showErr('Das Beispielteil dient zum Ausprobieren. Für Ihr Angebot legen Sie bitte Ihr eigenes Modell ab.'); return; }
        var p = collectTech();
        p._label = partLabel(p);
        addBtn.disabled = true;
        previewJetzt().then(function (L) {
          p._price = L && L.autoQuote ? L.vkOrderNet : null;
          p._auto = L ? !!L.autoQuote : null;
          state.parts.push(p);
          renderParts();
          resetTech();
          addBtn.disabled = false;
          if (einfach) startFokus(); else root.querySelector('.gw-qp-drop').focus();
          if (einfach) ansage('Teil ' + state.parts.length + ' in die Anfrage übernommen. Legen Sie das nächste Teil ab oder senden Sie die Anfrage.');
        });
      });
    }

    // ---- submit ----
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErr();
      var name = root.querySelector('[name="customerName"]').value.trim();
      var email = root.querySelector('[name="email"]').value.trim();
      if (einfach) {
        if (state.beispiel) { showErr('Das Beispielteil dient zum Ausprobieren. Für Ihr Angebot legen Sie bitte Ihr eigenes Modell ab.'); return; }
        root.querySelectorAll('[aria-invalid]').forEach(ungueltigWeg);
        var fehl = !name ? ['customerName', 'Bitte geben Sie Ihren Namen an.']
          : !email ? ['email', 'Bitte geben Sie Ihre E-Mail-Adresse an.']
          : !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) ? ['email', 'Diese E-Mail-Adresse sieht unvollständig aus.'] : null;
        if (fehl) {
          var fe = q(fehl[0]); showErr(fehl[1]);
          if (fe) { fe.setAttribute('aria-invalid', 'true'); if (errEl.id) fe.setAttribute('aria-describedby', ((fe.getAttribute('aria-describedby') || '') + ' ' + errEl.id).trim()); fokus(fe); }
          return;
        }
      }
      if (!name || !email) { showErr('Name und E-Mail erforderlich.'); return; }

      var contact = {
        customerName: name, company: root.querySelector('[name="company"]').value,
        email: email, phone: root.querySelector('[name="phone"]').value,
        poNumber: (root.querySelector('[name="poNumber"]') || {}).value || '',
        notes: (function () {
          // Service-Wunsch aus den Unterlagen-Karten mitgeben — sonst kreuzt der Kunde
          // "bitte erstellen" an und niemand bei uns erfaehrt es.
          var svc = root.querySelector('.gw-qp-svc:checked');
          var wunsch = svc ? (svc.getAttribute('data-svc') === 'cad'
            ? '[Service gewuenscht] CAD-Modell aus der Zeichnung erstellen (kostenlos bei Auftrag).'
            : '[Service gewuenscht] Fertigungszeichnung aus dem CAD-Modell erstellen (kostenlos bei Auftrag).') : '';
          var frei = root.querySelector('[name="notes"]').value || '';
          return wunsch ? (wunsch + (frei ? '\n' + frei : '')) : frei;
        })(),
        website: root.querySelector('[name="website"]').value
      };

      var body;
      if (state.parts.length > 0) {
        // Mehrteile-Anfrage: gesammelte Teile + (falls ausgefüllt) das aktuelle Formular-Teil.
        var parts = state.parts.map(function (p) {
          var c = {}; for (var k in p) if (k.charAt(0) !== '_') c[k] = p[k];
          return c;
        });
        if (!techEmpty()) {
          var err = validateTech();
          if (err) { showErr(einfach ? 'Das aktuelle Teil ist noch unvollständig. Ergänzen Sie die Maße oder setzen Sie es über „Teil zurücksetzen“ zurück, um nur die Liste zu senden.' : err + ' — oder Felder leeren, um nur die Teile-Liste zu senden.'); return; }
          parts.push(collectTech());
        }
        body = Object.assign({ parts: parts }, contact);
      } else {
        // Einzelteil (bisheriger Weg)
        var err1 = validateTech();
        if (err1) { showErr(err1); return; }
        body = Object.assign(collectTech(), contact);
      }

      var weg = submitWeg();
      if (einfach) { form.setAttribute('aria-busy', 'true'); barPruefen(); }
      submitBtn.disabled = true;
      if (submitTxt) submitTxt.textContent = weg.busy;
      root.classList.add('gw-qp-busy');
      // Konto-Ticket direkt vor dem Senden (15 min gültig) — passt die E-Mail nicht zum Konto, ignoriert der Server es.
      kontoTicket()
        .then(function (t) { if (t && t.ticket) body.kontoTicket = t.ticket; })
        .then(function () { return fetch(api + '/api/quote' + kz(false), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }); })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.success) renderResult(d, email);
          else showErr((d && d.error) || 'Fehler bei der Berechnung.');
        })
        .catch(function () { showErr('Netzwerkfehler — bitte später erneut versuchen.'); })
        .then(function () {
          submitBtn.disabled = false;
          updateSubmitLabel();
          root.classList.remove('gw-qp-busy');
          if (einfach) { form.removeAttribute('aria-busy'); barPruefen(); if (!form.hidden && fokusWeg()) fokus(submitBtn); }
        });
    });

    // ---- result ----
    function datumDe(iso) {
      try { return new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Berlin' }); } catch (e) { return ''; }
    }
    function renderResult(d, email) {
      var html;
      var vorteil = d.vorteil && d.vorteil.eur > 0 ? d.vorteil : null;
      var netto = d.vkOrderNet != null ? Math.round((d.vkOrderNet - (vorteil ? vorteil.eur : 0)) * 100) / 100 : null;
      var brutto = vorteil ? (netto != null ? Math.round(netto * 1.19 * 100) / 100 : null) : d.vkOrderGross;
      var kontoNote = d.konto && kontoSeite
        ? '<p class="gw-qp-res-note">Den Vorgang finden Sie jederzeit unter <a href="' + esc(kontoSeite) + '">Mein Konto</a>.</p>'
        : (d.vorgangUrl ? '<p class="gw-qp-res-note">Den Link zur Online-Ansicht finden Sie in der E-Mail.</p>' : '');
      var isBatch = !!d.batch && Array.isArray(d.parts) && d.parts.length > 1;
      var refText = isBatch ? d.parts.map(function (p) { return p.refNumber; }).join(' · ') : d.refNumber;
      var batchRows = isBatch
        ? '<div class="gw-qp-res-parts">' + d.parts.map(function (p, i) {
            return '<div class="gw-qp-part"><span class="gw-qp-part-n">' + (i + 1) + '</span>' +
              '<span class="gw-qp-part-lbl">' + p.quantity + ' Stk. · ' + esc(p.partTitle || ('Teil ' + (i + 1))) + '</span>' +
              '<span class="gw-qp-part-price">' + (p.vkOrderNet != null ? esc(eur(p.vkOrderNet)) + ' <em>netto</em>' : '<em>Prüfung</em>') + '</span></div>';
          }).join('') + '</div>'
        : '';
      if (d.autoQuoted) {
        html =
          '<div class="gw-qp-res-ic gw-qp-res-ok"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="9"/></svg></div>' +
          '<h3>' + (isBatch ? 'Ihr Sofortpreis — ' + d.parts.length + ' Teile' : 'Ihr Sofortpreis') + '</h3>' +
          '<p class="gw-qp-ref">Referenz ' + esc(refText) + '</p>' +
          batchRows +
          '<div class="gw-qp-price"><strong>' + eur(netto) + '</strong>' +
          '<span>netto' + (d.shippingEur != null ? ' · zzgl. ' + eur(versandNetto(d.shippingEur)) + ' Versand (Schätzung, netto)' : '') + '</span>' +
          (d.shopGross != null ? '<span class="gw-qp-gross">Gesamt an der Kasse: ' + eur(d.shopGross) + ' inkl. Versand und MwSt.</span>'
            : brutto != null ? '<span class="gw-qp-gross">' + eur(brutto) + ' inkl. 19 % MwSt., zzgl. Versand</span>' : '') +
          (vorteil ? '<span class="gw-qp-vorteil">Willkommensvorteil ' + String(vorteil.prozent).replace('.', ',') + ' % bereits abgezogen: −' + eur(vorteil.eur) + '</span>' : '') +
          (d.gueltigBis ? '<span class="gw-qp-gueltig">Preis gültig bis ' + datumDe(d.gueltigBis) + '</span>' : '') + '</div>' +
          (d.checkoutUrl ? '<a class="gw-btn gw-btn-primary gw-btn-lg gw-qp-buy" href="' + esc(d.checkoutUrl) + '" target="_blank" rel="noopener">Jetzt bestellen &amp; bezahlen →</a>' : '') +
          '<p class="gw-qp-res-note">Ihr Angebot mit Bestell-Link geht zusätzlich per E-Mail an <strong>' + esc(email) + '</strong>. Bestellt ist erst, wenn Sie bezahlen oder auf Rechnung bestellen.</p>' + kontoNote;
      } else {
        html =
          '<div class="gw-qp-res-ic gw-qp-res-wait"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg></div>' +
          '<h3>' + (isBatch ? 'Anfrage erhalten — ' + d.parts.length + ' Teile' : 'Anfrage erhalten') + '</h3>' +
          '<p class="gw-qp-ref">Referenz ' + esc(refText) + '</p>' +
          batchRows +
          '<p class="gw-qp-res-note">' + (isBatch ? 'Ihre Teile erfordern' : 'Ihr Teil erfordert') + ' eine kurze Prüfung von Hand. Sie erhalten Ihr Angebot <strong>spätestens binnen 24 Stunden</strong> an ' + esc(email) + '.</p>' + kontoNote;
      }
      html += '<button type="button" class="gw-qp-again">Weitere Anfrage stellen</button>';
      resultEl.innerHTML = html;
      form.hidden = true;
      root.querySelectorAll('.gw-qp-modes').forEach(function (e) { e.hidden = true; });
      resultEl.hidden = false;
      resultEl.querySelector('.gw-qp-again').addEventListener('click', function () {
        resultEl.hidden = true; resultEl.innerHTML = '';
        form.hidden = false;
        root.querySelectorAll('.gw-qp-modes').forEach(function (e) { e.hidden = false; });
        state.parts = []; renderParts();
        resetTech();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (einfach) { stufe(); fokus(root.querySelector('.gw-qp-drop-start')); }
      });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (einfach) { barPruefen(); var rh = resultEl.querySelector('h3'); if (rh) { rh.setAttribute('tabindex', '-1'); fokus(rh); } }
    }
    // Vorwahl per Adresse: ?verfahren=3d — z. B. „Neu anfragen“ aus dem Kundenkonto bei einem 3D-Druck-Vorgang.
    // Am Ende der Initialisierung, damit alle Zustände stehen.
    try { if (/^(3d|druck|print)$/i.test(new URLSearchParams(location.search).get('verfahren') || '')) setMode('print'); } catch (e) {}
  }

  function scan() { document.querySelectorAll('.gw-qp').forEach(initPortal); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
